import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Quote } from 'lucide-react'
import { Container } from '../layout/Container'
import { Card } from '../ui/Card'
import { useScrollAnimation } from '../../hooks/useScrollAnimation'
import type { Testimonial } from '../../types'

export function PainTestimonials() {
  const { t } = useTranslation()
  const { ref, isInView } = useScrollAnimation()

  const testimonials: Testimonial[] = t('painTestimonials.items', { returnObjects: true }) as Testimonial[]

  return (
    <section id="dolor" className="bg-surface py-24">
      <Container>
        <div className="mb-16 text-center">
          <span className="text-sm font-medium uppercase tracking-wider text-error">
            {t('painTestimonials.label')}
          </span>
          <h2 className="mt-4 text-3xl font-semibold text-text-primary md:text-4xl">
            {t('painTestimonials.title')}
          </h2>
        </div>

        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 32 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 32 }}
          transition={{ duration: 0.6 }}
          className="grid gap-6 md:grid-cols-3"
        >
          {testimonials.map((item, index) => (
            <Card key={item.id} variant="elevated" className="relative">
              <Quote className="absolute right-6 top-6 h-8 w-8 text-accent/20" />
              <div className="mb-4 flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-surface text-sm font-semibold text-accent-light">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <div>
                  <div className="text-sm font-medium text-text-primary">{item.role}</div>
                  <div className="text-xs text-text-muted">{item.area}</div>
                </div>
              </div>
              <blockquote className="text-text-secondary leading-relaxed">
                "{item.quote}"
              </blockquote>
            </Card>
          ))}
        </motion.div>
      </Container>
    </section>
  )
}
